import React from 'react';
import { PageLayout } from '@/shared/layout';
import { EquipmentKpiDashboard } from './components/EquipmentKpiDashboard';
import { EquipmentModulesGrid } from './components/EquipmentModulesGrid';
import { EquipmentRecentActivity } from './components/EquipmentRecentActivity';
import { EquipmentAIAssistant } from './components/EquipmentAIAssistant';

export function EquipmentPage() {
  return (
    <PageLayout
      title="Thiết bị & Máy móc"
      description="Trung tâm quản lý, điều phối thiết bị thi công và theo dõi khấu hao, sửa chữa."
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <EquipmentKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Vận hành Thiết bị (Fleet Management)
              </h3>
            </div>
            <div className="flex-1">
              <EquipmentModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Nhật ký hoạt động
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <EquipmentRecentActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default EquipmentPage;
